import ReactTooltip from 'react-tooltip';
import { FaRegTrashAlt } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import { ExceptionDut4 } from '../ExceptionEditCardDut4/types';
import { colors } from '~/styles/colors';
import {
  ExceptionCardRow,
  FieldTitle,
  FieldDate,
  FieldRepeat,
  FieldBeginTime,
  FieldEndTime,
  ButtonContainer,
  TooltipContent,
  IconWrapper,
} from './styles';
import { PenIcon } from '../../icons';

interface ComponentProps {
  exception: ExceptionDut4;
  cardPosition: number;
  hideButtons?: boolean;
  onHandleEdit?: (cardPosition: number) => void;
  onHandleDelete?: (exceptionId: number | undefined, cardPosition: number) => void;
}

export const ExceptionViewCardDut4 = (props: ComponentProps): JSX.Element => {
  const { t } = useTranslation();

  function exceptionTitle() {
    const overExtended = props.exception.EXCEPTION_TITLE.length > 19;
    const nameDisplay = !overExtended
      ? props.exception.EXCEPTION_TITLE
      : `${props.exception.EXCEPTION_TITLE.substring(0, 19)}...`;

    return (
      <>
        <div data-tip data-for={`exc-dut4-${props.cardPosition}`}>
          {nameDisplay}
        </div>
        {overExtended && (
          <ReactTooltip
            id={`exc-dut4-${props.cardPosition}`}
            place="top"
            effect="solid"
            delayHide={100}
            offset={{ top: 0, left: 10 }}
            textColor={colors.Black}
            border
            backgroundColor="rgba(255, 255, 255, 0.97)"
          >
            <TooltipContent>
              <strong>{props.exception.EXCEPTION_TITLE}</strong>
            </TooltipContent>
          </ReactTooltip>
        )}
      </>
    );
  }

  return (
    <ExceptionCardRow>
      <FieldTitle>
        {exceptionTitle()}
      </FieldTitle>
      <FieldDate>
        {(() => {
          const d = props.exception.EXCEPTION_DATE;
          let display = d;
          if (/^\d{4}-\d{2}-\d{2}$/.test(d)) {
            display = `${d.substring(8, 10)}/${d.substring(5, 7)}/${d.substring(0, 4)}`;
          }
          return props.exception.REPEAT_YEARLY ? display.substring(0, 5) : display;
        })()}
      </FieldDate>
      <FieldRepeat>
        {props.exception.REPEAT_YEARLY ? t('sim') : t('nao')}
      </FieldRepeat>
      <FieldBeginTime>
        {props.exception.BEGIN_TIME}
      </FieldBeginTime>
      <FieldEndTime>
        {props.exception.END_TIME}
      </FieldEndTime>
      {!props.hideButtons && (
        <>
          <ButtonContainer>
            <IconWrapper
              data-testid="exception-edit-btn"
              onClick={(e) => { e.preventDefault(); props.onHandleEdit?.(props.cardPosition); }}
            >
              <PenIcon />
            </IconWrapper>
          </ButtonContainer>
          <ButtonContainer>
            <FaRegTrashAlt
              data-testid="exception-delete-btn"
              color={colors.Pink200}
              onClick={(e) => {
                e.preventDefault();
                if (window.confirm(`Deseja excluir a exceção ${props.exception.EXCEPTION_TITLE}?`)) {
                  props.onHandleDelete?.(props.exception.DUT_EXCEPTION_ID, props.cardPosition);
                }
              }}
            />
          </ButtonContainer>
        </>
      )}
    </ExceptionCardRow>
  );
};
